import { useMemo } from "react"
import { Box, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { FrequencyBarSegment } from "./frequency-bar-segment"
import { VisitFrequencyLegendItem } from "./visit-frequency-legend-item"

const FREQUENCY_CONFIG = [
    { key: "daily", label: "Daily", color: "#0F2A33" },
    { key: "weekly", label: "Weekly", color: "#265b6f" },
    { key: "monthly", label: "Monthly", color: "#35818B" },
    { key: "quarterly", label: "3 Monthly", color: "#6AA3AB" },
    { key: "biannual", label: "6 Monthly", color: "#A0C4CA" },
    { key: "yearly", label: "Yearly+", color: "#637381" },
]

export function VisitFrequencyChart({ visitSnapshot, currencySymbol }) {
    const segments = useMemo(buildSegments, [visitSnapshot])
    const totalCost = useMemo(getTotalCost, [segments])

    return (
        <Stack spacing={1.5}>
            <If value={segments.length > 0}>
                <Box sx={{ display: "flex", height: 12, borderRadius: 1, overflow: "hidden", bgcolor: "action.hover" }}>
                    <Repeat
                        list={segments}
                        item={<FrequencyBarSegment totalCost={totalCost} currencySymbol={currencySymbol} />}
                    />
                </Box>
                <Stack spacing={1.25}>
                    <Repeat
                        list={segments}
                        item={<VisitFrequencyLegendItem totalCost={totalCost} currencySymbol={currencySymbol} />}
                    />
                </Stack>
                <Else>
                    <Typography variant="caption" color="text.secondary">
                        No visit cost data available
                    </Typography>
                </Else>
            </If>
        </Stack>
    )

    function buildSegments() {
        if (!visitSnapshot) return []
        return FREQUENCY_CONFIG.filter(hasNonZeroCost).map(toSegment)
    }

    function hasNonZeroCost(config) {
        const bucket = visitSnapshot[config.key]
        return bucket && bucket.cost > 0
    }

    function toSegment(config) {
        const bucket = visitSnapshot[config.key]
        return {
            key: config.key,
            label: config.label,
            color: config.color,
            cost: bucket.cost,
            visits: bucket.visits,
        }
    }

    function getTotalCost() {
        return segments.reduce((sum, s) => sum + s.cost, 0)
    }
}
